module.exports = __webpack_public_path__ + "img/fb.bb84eab9.png";